import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { FONTS, MAX_ROWS_FAST, PRIMARY_COLOR } from "../../constants";
import { stateTypeF } from "../../state";
import { HelpIcon } from "../Common/ToolTipIcon";
import { FastTrianingCheck } from "../ModelTraining/ModelTrainingBox";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    groupDescTitle: {
      fontSize: "20px",
      fontFamily: FONTS,
      textAlign: "left",
      margin: "20px",
      width: "100%",
      fontWeight: "bold",
      display: "flex",
      flexDirection: "row",
    },
    container: { display: "flex", flexDirection: "column" },
  })
);

export function Line() {
  return (
    <div
      style={{
        width: "97%",
        height: "1px",
        backgroundColor: "rgba(0,0,0,0.2)",
        position: "relative",
        marginTop: "-10px",
        zIndex: 1000,
        color: "white",
      }}
    ></div>
  );
}

export function LineWhite() {
  return (
    <div
      style={{
        width: "97%",
        height: "1px",
        backgroundColor: "white",
        position: "relative",
        marginTop: "-10px",
        zIndex: 1000,
        color: "white",
      }}
    ></div>
  );
}

export function Line100() {
  return (
    <div
      style={{
        width: "100vw",
        height: "1px",
        backgroundColor: "rgba(0,0,0,0.2)",
        position: "relative",
        marginTop: "-10px",
        zIndex: 1000,
        marginLeft: "-10%",
      }}
    ></div>
  );
}

type boxHeaderType = {
  title: string;
  toolTip: string;
  color?: string;
  bold?: boolean;
  justify?: boolean;
  showTip?: boolean;
  line?: boolean;
};
type boxHeaderType2 = {
  title: string;
  toolTip: string;
  state: stateTypeF;
  color?: string;
  bold?: boolean;
  justify?: boolean;
  showTip?: boolean;
  line?: boolean;
};

export function BoxHeader2({
  title,
  toolTip,
  color = PRIMARY_COLOR,
  bold = true,
  justify = false,
  showTip = true,
  line = true,
  state,
}: boxHeaderType2) {
  const classes = useStyles();
  const isLargeDataset =
    state.saveState.dataset.columns[0].vectorizedData.length > MAX_ROWS_FAST;
  return (
    <div className={classes.container}>
      <div
        className={classes.groupDescTitle}
        style={{
          color: color,
          fontWeight: bold ? "bold" : "normal",
          justifyContent: justify ? "center" : "left",
          marginLeft: justify ? "-10px" : "20px",
          marginTop: justify ? "10px" : "20px",
        }}
      >
        {title}
        {showTip ? (
          <HelpIcon
            title={toolTip}
            marginLeft={"5px"}
            paddingTop={"0px"}
          ></HelpIcon>
        ) : (
          <div></div>
        )}
        <div
          style={{
            marginLeft: "auto",
            marginRight: "200px",
            fontSize: "16px",
          }}
        >
          {isLargeDataset ? (
            <FastTrianingCheck state={state}></FastTrianingCheck>
          ) : (
            <div></div>
          )}
        </div>
      </div>
      <div style={{ width: "100%", justifyContent: "center", display: "flex" }}>
        {justify ? (
          <div> </div>
        ) : line ? (
          color === "white" ? (
            <LineWhite></LineWhite>
          ) : (
            <Line></Line>
          )
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
}

export function BoxHeader({
  title,
  toolTip,
  color = PRIMARY_COLOR,
  bold = true,
  justify = false,
  showTip = true,
  line = true,
}: boxHeaderType) {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div
        className={classes.groupDescTitle}
        style={{
          color: color,
          fontWeight: bold ? "bold" : "normal",
          justifyContent: justify ? "center" : "left",
          marginLeft: justify ? "-10px" : "20px",
          marginTop: justify ? "10px" : "20px",
        }}
      >
        {title}
        {showTip ? (
          <HelpIcon
            title={toolTip}
            marginLeft={"5px"}
            paddingTop={"0px"}
          ></HelpIcon>
        ) : (
          <div></div>
        )}
      </div>
      <div style={{ width: "100%", justifyContent: "center", display: "flex" }}>
        {justify ? (
          <div> </div>
        ) : line ? (
          color === "white" ? (
            <LineWhite></LineWhite>
          ) : (
            <Line></Line>
          )
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
}
